// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
// signIn: this.domainName + `/login?response_type=` + this.code + `&client_id=`+ this.clientId +`&redirect_uri=` + this.redirectUri,

const signInConfig = {
  WEB_PROTOCOL:'https://',
  DOMAIN_NAME: 'dev-cbm-contractor.auth.ap-southeast-1.amazoncognito.com',
  CLIENT_ID: '7i5osehk9p87lfq3gctjltb2fn',
  RESPONSE_TYPE: 'code',  // or 'token', note that REFRESH token will only be generated when the responseType is code
  REDIRECT_SIGN_IN: 'https://dev.cbm-contractor.meco-soldel.com/login',
  REDIRECT_SIGN_OUT: 'https://dev.cbm-contractor.meco-soldel.com/',
  // REDIRECT_SIGN_IN: 'http://localhost:4200/login',
  // REDIRECT_SIGN_OUT: 'http://localhost:4200/',
  SCOPE: ['phone', 'email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
  USER_POOL_ID: 'ap-southeast-1_fKh5f2vDz',
  IDENTITY_POOL_ID: 'ap-southeast-1:92e9236b-ec70-4a77-97d1-6c549f925cdc',

}

export const environment = {
  production: false,

  // DEFAULT PAGES
  contractor_home: 'service-request/search',

  // API FOR CBM - NEO4J
  hostURL: 'https://cbm-api.dev.meco-soldel.com',
  // hostURL: 'https://sqt.cbm-api.meco-soldel.com',

  // AMPLIFY environments
  domainName: `${signInConfig.DOMAIN_NAME}`,
  userPoolId: `${signInConfig.USER_POOL_ID}`,
  identityPoolId: `${signInConfig.IDENTITY_POOL_ID}`,
  clientId: `${signInConfig.CLIENT_ID}`,
  responseType: `${signInConfig.RESPONSE_TYPE}`,
  redirectUri: `${signInConfig.REDIRECT_SIGN_IN}`,
  redirectSignIn: `${signInConfig.REDIRECT_SIGN_IN}`,
  redirectSignOut: `${signInConfig.REDIRECT_SIGN_OUT}`,
  scope: `${signInConfig.SCOPE}`,
  signIn: `${signInConfig.WEB_PROTOCOL}${signInConfig.DOMAIN_NAME}/login?response_type=${signInConfig.RESPONSE_TYPE}&client_id=${signInConfig.CLIENT_ID}&redirect_uri=${signInConfig.REDIRECT_SIGN_IN}`,
  signOut: `${signInConfig.WEB_PROTOCOL}${signInConfig.DOMAIN_NAME}/logout?client_id=${signInConfig.CLIENT_ID}&logout_uri=${signInConfig.REDIRECT_SIGN_OUT}`

};
// https://cbm-admin-dev.auth.ap-southeast-1.amazoncognito.com/login?client_id=4efofql74344qlibvqoag249d4&response_type=code&scope=aws.cognito.signin.user.admin+email+openid+profile&redirect_uri=https://dev.cbm-admin.meco-soldel.com/login
